import { VIC_DATES_JSON_PATH } from '#shared/constants';
import type { VicDatesSnapshot } from '#shared/vicDatesTypes';

import committedVicDates from '../public/events/vic-dates.json';

let cachedVicDates: VicDatesSnapshot | null = null;

export const fetchVicDates = async (): Promise<VicDatesSnapshot | null> => {
  if (cachedVicDates) {
    return cachedVicDates;
  }

  if (process.env.NODE_ENV === 'development') {
    cachedVicDates = committedVicDates as VicDatesSnapshot;
    return cachedVicDates;
  }

  try {
    const response = await fetch(VIC_DATES_JSON_PATH);
    if (!response.ok) {
      return null;
    }
    cachedVicDates = (await response.json()) as VicDatesSnapshot;
    return cachedVicDates;
  } catch {
    return null;
  }
};
